exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".detail-group[data-v-1dd330eb] {\n  padding: 2px 16px;\n  margin: 5px 0;\n  font-size: 0.9em;\n}\n.detail-group .label[data-v-1dd330eb] {\n    display: inline-block;\n    width: 100px;\n    margin-right: 4px;\n    vertical-align: top;\n    font-weight: 400;\n}\n.detail-group .value[data-v-1dd330eb] {\n    display: inline-block;\n    width: calc(100% - 105px);\n    vertical-align: top;\n}\n.detail-group .value a[data-v-1dd330eb] {\n      color: #2b93ff;\n}\n", ""]);

// exports
